import { useGetAverages } from 'infrastructure/hooks/rpm';
import { AVERAGE_UNITS } from 'infrastructure/consts/average-units';
import BaseSelect from 'components/molecules/select/base';
import { useTranslation } from 'react-i18next';
import { useState, type FC } from 'react';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import useUser from 'utils/useUser';
import { endOfDay, lastDayOfMonth } from 'date-fns';

import s from './styles.module.scss';

interface IOption {
  value: 'averages30' | 'averages90';
  label: string;
}
const options: IOption[] = [
  { value: 'averages30', label: '30 Days' },
  { value: 'averages90', label: '90 Days' },
];

interface AveragesProps {
  patientGuid: string;
  endTime: number;
}

const Averages: FC<AveragesProps> = ({ patientGuid, endTime }) => {
  const { averages, isLoading } = useGetAverages({
    patientGuid,
    endTime: endOfDay(lastDayOfMonth(endTime)).getTime(),
  });
  const { isMobileDevice } = useUser();
  const { t } = useTranslation();
  const [currentPeriod, setCurrentPeriod] = useState<IOption>(options[0]);

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <div className={s.wrapper}>
        <div className={s.select}>
          <BaseSelect
            options={options}
            label={
              isMobileDevice
                ? t('overviewDashboard.patientAverages')
                : t('labels.averages')
            }
            onSelect={(val) => {
              setCurrentPeriod(val);
            }}
            value={currentPeriod}
            allowClear={false}
            width={isMobileDevice ? '50%' : undefined}
          />
        </div>
        {averages?.[currentPeriod.value].map((average, idx) => {
          const { name, value } = average;
          const isValueValid = Boolean(parseInt(value));

          return (
            <div className={s.average} key={idx}>
              <p>{name}</p>
              <p data-empty={!isValueValid}>
                {isValueValid ? value : '-/-'}
                <span>{AVERAGE_UNITS[name]}</span>
              </p>
            </div>
          );
        })}
      </div>
    </BaseSpinWrapper>
  );
};
export default Averages;
